import singleCardEdit from '@/entities/insights/modal/edit-reference/single-card-edit/single-card-edit.vue';
import PublicService from '@/service/public.service';
import { documentCard } from '@/shared/model/document-card.model';
import { getDomainFromUrl, onlyInLeft, timeDifference, toDataURL } from '@/util/ds-util';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'report-web',
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
    'single-card': singleCardEdit,
  },
})
export default class reportWeb extends Vue {
  @Inject('publicService')
  publicService: () => PublicService;
  scrollSettings = {
    wheelPropagation: false,
  };
  searchValue = '';
  isShowSpinner = false;
  previewModels = [];

  preview() {
    if (!this.searchValue || this.searchValue == '') {
      return;
    }
    this.isShowSpinner = true;
    if (!this.previewModels) {
      this.previewModels = [];
    }
    const connectome = JSON.parse(localStorage.getItem('localStorageUser'));
    const connectomeId = connectome.connectomeId;
    this.publicService()
      .previewInfoByUrl(this.searchValue, connectomeId)
      .then(async res => {
        this.isShowSpinner = false;
        if (this.previewModels.length > 0 && res.data.url && this.previewModels.find(item => item.url == res.data.url)) {
          this.resetPreview();
          return;
        }
        const obj = new documentCard();
        if (res.data.author) obj.author = res.data.author;
        else obj.author = getDomainFromUrl(res.data.url);
        obj.title = res.data.title;
        obj.content = res.data.desc;
        obj.keyword = res.data.keyword;
        obj.type = 'URL';
        obj.searchType = 'WEB';
        if (obj.addedAt) obj.addedAt = timeDifference(new Date(), new Date(res.data.publicTime));
        obj.url = res.data.url;
        obj.images = [res.data.image ? res.data.image : res.data.imageAlt ? res.data.imageAlt : null];
        if (res.data.favicon) obj.favicon = await toDataURL(res.data.favicon);
        obj.noConvertTime = true;
        obj.typeRemove = 'web';
        this.previewModels.push(obj);
        this.selectedItems.push(obj);
        this.resetPreview();
      })
      .catch(() => {
        this.resetPreview();
        this.isShowSpinner = false;
      });
  }

  resetPreview() {
    this.searchValue = null;
  }

  totalSelected = 0;
  selectedItems = [];
  checked = false;

  selectAll() {
    if (this.selectedItems.length === this.previewModels.length) this.selectedItems = [];
    else this.selectedItems = this.previewModels;
  }
  @Watch('selectedItems')
  watchSelectedItems() {
    this.totalSelected = this.selectedItems.length;
  }

  @Watch('previewModels')
  dataChange() {
    const arrRight = this.checkArraySelected(true);
    if (arrRight && arrRight.length > 0) {
      for (const item of arrRight) {
        let i = 0;
        while (i < this.selectedItems.length) {
          if (this.selectedItems[i].link == item.link) {
            this.selectedItems.splice(i, 1);
            break;
          }
          i++;
        }
      }
    }

    this.selectedItems.length === this.previewModels.length ? $('#btnSelect').addClass('active') : $('#btnSelect').removeClass('active');
    this.totalSelected = this.selectedItems.length;
  }

  checkArraySelected(arg?) {
    if (arg) return onlyInLeft(this.selectedItems, this.previewModels, ['url']);
    return onlyInLeft(this.previewModels, this.selectedItems, ['url']);
  }

  setSelectedItems(newData) {
    this.selectedItems = newData;
    this.totalSelected = this.selectedItems.length;
  }

  deleteAll() {
    this.selectedItems.splice(0, this.selectedItems.length);
  }

  removeCardReq(item) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) this.selectedItems.splice(index, 1);
  }

  resetListSelected() {
    this.selectedItems.splice(0, this.selectedItems.length);
  }

  removeCardInList(item) {
    const index = this.previewModels.indexOf(item);
    if (index !== -1) this.previewModels.splice(index, 1);
    this.removeCardReq(item);
  }

  clearModalData() {
    this.previewModels.splice(0, this?.previewModels?.length);
    this.resetPreview();
    this.resetListSelected();
  }

  addToReference() {
    this.$root.$emit('add-to-lst-reference', this.selectedItems);
    // @ts-ignore
    window.$('#modal-web-report').modal('hide');
  }

  nextAndPre(next?) {
    next
      ? $('#scroll-div-report-web').append($('#scroll-div-report-web').find('li:first-child'))
      : $('#scroll-div-report-web').append($('#scroll-div-report-web').find('li:last-child'));
  }

  created() {
    this.$root.$on('clear-modal-data-web', this.clearModalData);
  }

  destroyed() {
    this.$root.$off('clear-modal-data-web', this.clearModalData);
  }
}
